var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 372.9 202.6",
    style: {
      enableBackground: "new 0 0 372.9 202.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFDC00;}\r\n\t.st1{fill:#004C9B;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 257.3,
    className: "st0",
    width: 115.7,
    height: 176.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 25.9,
    className: "st1",
    width: 347,
    height: 176.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.2,53H41.9l-0.5,0.5v28.9l-0.5,0.5h-6.2l-0.5-0.5V53.5L33.7,53H23.3l-0.5-0.5v-5.2l0.5-0.5h28.9l0.5,0.5 v5.2L52.2,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,83.4c-7.7,0-12.9-5.2-12.9-13.4s5.2-13.4,12.9-13.4S74,61.8,74,70S68.9,83.4,61.1,83.4z M61.1,62.8 c-3.6,0-5.7,2.6-5.7,7.2s2.1,7.2,5.7,7.2s5.7-2.6,5.7-7.2S64.8,62.8,61.1,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95,63.3h-3.6c-4.1,0-5.7,2.1-5.7,6.7v12.4l-0.5,0.5H79l-0.5-0.5V57.7l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5 c0,0,1-2.1,5.7-2.1H95l0.5,0.5v5.2L95,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.3,83.4c-7.7,0-12.9-5.2-12.9-13.4s5.2-13.4,12.9-13.4s12.9,5.2,12.9,13.4S117,83.4,109.3,83.4z  M109.3,62.8c-3.6,0-5.7,2.6-5.7,7.2s2.1,7.2,5.7,7.2s5.7-2.6,5.7-7.2S112.9,62.8,109.3,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.2,82.9H144l-0.5-0.5V67.5c0-2.6-1-4.6-4.1-4.6c-3.6,0-5.7,2.1-5.7,6.7v12.9l-0.5,0.5H127l-0.5-0.5V57.7 l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5c1-1,3.1-2.6,6.7-2.6c6.2,0,9.8,4.1,9.8,10.3v15.5L150.2,82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165.5,75.2c0,1,0.5,1.6,1.6,1.6h4.6l0.5,0.5v5.2l-0.5,0.5h-4.6c-4.6,0-8.8-2.1-8.8-7.7V63.9l-0.5-0.5h-3.6 l-0.5-0.5v-5.2l0.5-0.5h3.6l0.5-0.5V52l0.5-0.5h6.2l0.5,0.5v4.6l0.5,0.5h5.7l0.5,0.5v5.2l-0.5,0.5h-5.7l-0.5,0.5L165.5,75.2 L165.5,75.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.5,83.4c-7.7,0-12.9-5.2-12.9-13.4s5.2-13.4,12.9-13.4s12.9,5.2,12.9,13.4S195.3,83.4,187.5,83.4z  M187.5,62.8c-3.6,0-5.7,2.6-5.7,7.2s2.1,7.2,5.7,7.2s5.7-2.6,5.7-7.2S191.1,62.8,187.5,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.8,162.7c0,9.3-5.2,14.4-14.4,14.4s-14.4-5.2-14.4-14.4V141l0.5-0.5h6.2l0.5,0.5v21.7 c0,5.2,2.1,8.2,7.2,8.2s7.2-3.1,7.2-8.2V141l0.5-0.5h6.2l0.5,0.5L54.8,162.7L54.8,162.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.8,176.6h-6.2l-0.5-0.5v-14.9c0-2.6-1-4.6-4.1-4.6c-3.6,0-5.7,2.1-5.7,6.7v12.9l-0.5,0.5h-6.2l-0.5-0.5 v-24.8l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5c1-1,3.1-2.6,6.7-2.6c6.2,0,9.8,4.1,9.8,10.3v15.5L83.8,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.5,146.7h-6.2l-0.5-0.5V141l0.5-0.5h6.2L97,141v5.2L96.5,146.7z M96.5,176.6h-6.2l-0.5-0.5v-24.8l0.5-0.5 h6.2l0.5,0.5v24.8L96.5,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.7,176.1l-0.5,0.5h-5.7l-0.5-0.5l-8.8-19.6v-5.2l0.5-0.5h4.6l0.5,0.5l6.2,16h0.5l6.2-16l0.5-0.5h4.6 l0.5,0.5v5.2L116.7,176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.9,165.8l-0.5,0.5h-16l-0.5,0.5c0,1,1,4.1,5.2,4.1c1.6,0,3.1-0.5,3.6-1.6l0.5-0.5h6.2l0.5,0.5 c-0.5,3.1-3.1,7.7-10.8,7.7c-8.8,0-12.9-6.2-12.9-13.4s4.1-13.4,12.4-13.4s12.4,6.2,12.4,13.4L152.9,165.8L152.9,165.8z  M145.2,160.6c0-0.5-0.5-4.1-4.6-4.1c-4.1,0-4.6,3.6-4.6,4.1l0.5,0.5h8.2L145.2,160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.6,157H170c-4.1,0-5.7,2.1-5.7,6.7v12.4l-0.5,0.5h-6.2l-0.5-0.5v-24.8l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5 c0,0,1-2.1,5.7-2.1h3.1l0.5,0.5v5.1L173.6,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.9,177.1c-7.2,0-11.3-3.6-11.3-8.8l0.5-0.5h6.2l0.5,0.5c0,2.1,1.6,2.6,4.1,2.6s4.1-0.5,4.1-2.1 c0-2.1-2.1-2.1-5.2-2.6s-9.8-2.1-9.8-8.2c0-4.1,3.1-7.7,10.8-7.7c6.2,0,10.8,2.6,10.8,7.7l-0.5,0.5H192l-0.5-0.5c0-1-1-1.6-3.6-1.6 s-3.6,0.5-3.6,2.1c0,2.1,3.1,2.1,6.2,2.6c3.1,0.5,8.8,1.6,8.8,7.7C199.2,173,196.1,177.1,187.9,177.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.1,146.7H204l-0.5-0.5V141l0.5-0.5h6.2l0.5,0.5v5.2L210.1,146.7z M210.1,176.6H204l-0.5-0.5v-24.8l0.5-0.5 h6.2l0.5,0.5v24.8L210.1,176.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M226.5,168.9c0,1,0.5,1.6,1.5,1.6h4.6l0.5,0.5v5.2l-0.5,0.5H228c-4.6,0-8.8-2.1-8.8-7.7v-11.3l-0.5-0.5h-3.6 l-0.5-0.5v-5.2l0.5-0.5h3.6l0.5-0.5v-4.6l0.5-0.5h6.2l0.5,0.5v4.6l0.5,0.5h5.7l0.5,0.5v5.2l-0.5,0.5H227l-0.5,0.5L226.5,168.9 L226.5,168.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M252.6,177.1c-2.1,5.2-4.1,8.2-11.3,8.2h-2.6l-0.5-0.5v-5.2l0.5-0.5h2.6c2.6,0,3.1-0.5,3.6-2.1v-0.5l-8.2-20.1 v-5.2l0.5-0.5h4.6l0.5,0.5l6.2,17.5h0.5l6.2-17.5l0.5-0.5h4.6l0.5,0.5v5.2L252.6,177.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "61.5,129.8 55.3,129.8 54.8,129.3 54.8,109.6 54.3,109.6 47.4,129.3 46.8,129.8 41.2,129.8  40.7,129.3 33.7,109.6 33.2,109.6 33.2,129.3 32.6,129.8 26.4,129.8 25.9,129.3 25.9,94.2 26.4,93.7 34.2,93.7 34.7,94.2  43.8,119.5 44.3,119.5 53.3,94.2 53.8,93.7 61.5,93.7 62,94.2 62,129.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.2,118.9l-0.5,0.5h-16l-0.5,0.5c0,1,1,4.1,5.2,4.1c1.6,0,3.1-0.5,3.6-1.6l0.5-0.5h6.2l0.5,0.5 c-0.5,3.1-3.1,7.7-10.8,7.7c-8.8,0-12.9-6.2-12.9-13.4s4.1-13.4,12.4-13.4s12.4,6.2,12.4,13.4L91.2,118.9L91.2,118.9z M83.4,113.8 c0-0.5-0.5-4.1-4.6-4.1c-4.1,0-4.6,3.6-4.6,4.1l0.5,0.5h8.2L83.4,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.9,122c0,1,0.5,1.6,1.6,1.6h4.6l0.5,0.5v5.2l-0.5,0.5h-4.6c-4.6,0-8.8-2.1-8.8-7.7v-11.3l-0.5-0.5h-3.6 l-0.5-0.5v-5.2l0.5-0.5h3.6l0.5-0.5v-4.6l0.5-0.5h6.2l0.5,0.5v4.6l0.5,0.5h5.7l0.5,0.5v5.2l-0.5,0.5h-5.7l-0.5,0.5L104.9,122 L104.9,122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.1,110.2h-3.6c-4.1,0-5.7,2.1-5.7,6.7v12.4l-0.5,0.5h-6.2l-0.5-0.5v-24.8l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5 c0,0,1-2.1,5.7-2.1h3.1l0.5,0.5v5.2L133.1,110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M147.4,130.3c-7.7,0-12.9-5.2-12.9-13.4s5.2-13.4,12.9-13.4s12.9,5.2,12.9,13.4 C160.3,125.1,155.1,130.3,147.4,130.3z M147.4,109.7c-3.6,0-5.7,2.6-5.7,7.2s2.1,7.2,5.7,7.2s5.7-2.6,5.7-7.2 S151,109.7,147.4,109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M179.1,130.3c-4.6,0-6.7-2.6-6.7-2.6h-0.5V140l-0.5,0.5h-6.2l-0.5-0.5v-35.5l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5 c0,0,2.1-2.6,6.7-2.6c6.2,0,11.3,5.2,11.3,13.4S185.3,130.3,179.1,130.3z M177.5,109.7c-4.1,0-5.7,3.1-5.7,7.2s1.6,7.2,5.7,7.2 c4.1,0,5.7-3.1,5.7-7.2S181.6,109.7,177.5,109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.2,130.3c-7.7,0-12.9-5.2-12.9-13.4s5.2-13.4,12.9-13.4s12.9,5.2,12.9,13.4 C219.1,125.1,214,130.3,206.2,130.3z M206.2,109.7c-3.6,0-5.7,2.6-5.7,7.2s2.1,7.2,5.7,7.2s5.7-2.6,5.7-7.2 S209.8,109.7,206.2,109.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M230.2,129.8H224l-0.5-0.5V94.2l0.5-0.5h6.2l0.5,0.5v35.1L230.2,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M243.4,99.9h-6.2l-0.5-0.5v-5.2l0.5-0.5h6.2l0.5,0.5v5.2L243.4,99.9z M243.4,129.8h-6.2l-0.5-0.5v-24.8 l0.5-0.5h6.2l0.5,0.5v24.8L243.4,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M259.8,122c0,1,0.5,1.6,1.5,1.6h4.6l0.5,0.5v5.2l-0.5,0.5h-4.6c-4.6,0-8.8-2.1-8.8-7.7v-11.3l-0.5-0.5h-3.6 l-0.5-0.5v-5.2l0.5-0.5h3.6l0.5-0.5v-4.6l0.5-0.5h6.2l0.5,0.5v4.6l0.5,0.5h5.7l0.5,0.5v5.2l-0.5,0.5h-5.7l-0.5,0.5L259.8,122 L259.8,122z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.5,129.8h-5.7l-0.5-0.5l-0.5-1h-0.5c0,0-2.1,2.1-5.7,2.1c-5.7,0-9.3-3.1-9.3-8.2c0-7.7,7.2-8.8,11.3-8.8 c2.1,0,3.6,0.5,3.6,0.5l0.5-0.5v-0.5c0-2.6-0.5-3.1-3.6-3.1c-1.5,0-3.1,0-3.6,1.6l-0.5,0.5h-6.2l-0.5-0.5c0-3.1,2.6-7.7,10.8-7.7 s10.8,4.1,10.8,11.9v13.9L291.5,129.8z M284.3,118.9c0,0-1-0.5-3.1-0.5c-3.1,0-4.6,1-4.6,3.1c0,1.6,1,2.6,3.6,2.6 c2.6,0,4.6-1.6,4.6-3.6v-1L284.3,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.1,129.8h-6.2l-0.5-0.5v-14.9c0-2.6-1-4.6-4.1-4.6c-3.6,0-5.7,2.1-5.7,6.7v12.9l-0.5,0.5h-6.2l-0.5-0.5 v-24.8l0.5-0.5h5.7l0.5,0.5l0.5,1.6h0.5c1-1,3.1-2.6,6.7-2.6c6.2,0,9.8,4.1,9.8,10.3v15.5L321.1,129.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmu);
export default __webpack_public_path__ + "static/media/tmu.e1fbb82e02411fb5a4a9566de2cc2f5e.svg";
export { ForwardRef as ReactComponent };